// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29rKl","label":"styles_label__1vvx7"};